@import "tailwindcss";
@config "../tailwind.config.js";

@theme {
  --shadow-card: 0 2px 12px rgba(0,0,0,0.5);
  --shadow-elevation-2: 0 4px 12px rgba(0,0,0,0.4);
  --shadow-elevation-4: 0 16px 48px rgba(0,0,0,0.6);
}

@layer base {
  html {
    scroll-behavior: smooth;
    font-size: 16px;
  }
  html[data-mode="light"] { color-scheme: light; }
  html[data-mode="dark"] { color-scheme: dark; }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    background: var(--bg, #141414);
    color: var(--text, #f5f0e8);
    letter-spacing: -0.01em;
  }

  /* Display font for headings/big values */
  .font-display { font-family: 'Space Grotesk', 'Inter', sans-serif; letter-spacing: -0.02em; }
  /* Mono for numbers */
  .font-num { font-family: 'JetBrains Mono', ui-monospace, monospace; font-feature-settings: 'tnum'; }

  #root {
    width: 100%;
    min-height: 100svh;
    display: flex;
    flex-direction: column;
  }

  ::-webkit-scrollbar { width: 5px; height: 5px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }
}

@keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.3; } }

/* Live-tick: brief highlight when a number updates from the 10s FX refresh */
@keyframes numTick {
  0% { color: var(--pos); text-shadow: 0 0 14px color-mix(in srgb, var(--pos) 60%, transparent); }
  100% { color: inherit; text-shadow: none; }
}
.num-tick { animation: numTick .7s ease-out; }

/* Accent-aware card hover: lift + colored border + colored glow (per-card via --card-accent) */
.dash-card {
  transition: transform .22s cubic-bezier(.2,.7,.3,1), box-shadow .28s ease, border-color .28s ease;
  will-change: transform;
}
.dash-card:hover {
  transform: translateY(-5px);
  background:
    linear-gradient(135deg,
      color-mix(in srgb, var(--card-accent, var(--accent)) 26%, transparent),
      color-mix(in srgb, var(--card-accent, var(--accent)) 7%, transparent)) !important;
  border-color: color-mix(in srgb, var(--card-accent, var(--accent)) 70%, transparent) !important;
  box-shadow:
    0 18px 40px -10px var(--card-accent-glow, rgba(0,0,0,.4)),
    0 0 0 1px color-mix(in srgb, var(--card-accent, var(--accent)) 45%, transparent),
    inset 0 1px 0 rgba(255,255,255,.08) !important;
}
.dash-card:hover .card-glow { opacity: 1; transform: scale(1.15); }
.card-glow { transition: opacity .3s ease, transform .4s ease; }

@media (prefers-reduced-motion: reduce) {
  * { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; }
}
